import axios from 'axios';

export default {
  login(payload) {
    return axios.post('./api/login', payload);
  },
  logout() {
    return axios.post('./api/logout');
  }
}